// @flow

import React from "react";

import {
  ReplyMessageContainer,
  ReplyMessageContent,
  CloseIcon,
} from "../styles";
import Notification from "./Notification";
import MessageText from "src/components/messages/MessageText";
import NameOrEmail from "src/containers/user/NameOrEmail";
import { Reply as StyledReply } from "src/styles";
import * as colors from "src/styles/constants/colors";
import Icon from "src/icons";

type Props = {
  currentMessage: Object,
  clearReplyTo: () => void,
};

const Reply = ({ currentMessage, clearReplyTo }: Props) => {
  const { action, author } = currentMessage;

  return (
    <StyledReply>
      <ReplyMessageContainer>
        <div>
          <NameOrEmail uid={author} notificationVariant="key" />
          {action ? (
            <Notification message={currentMessage} />
          ) : (
            <ReplyMessageContent>
              <MessageText message={currentMessage} />
            </ReplyMessageContent>
          )}
        </div>
      </ReplyMessageContainer>
      <CloseIcon>
        <Icon
          type="close"
          color={colors.secondary}
          handleClick={clearReplyTo}
          cursor="pointer"
        />
      </CloseIcon>
    </StyledReply>
  );
};

export default Reply;
